import React from 'react';
import { Typography } from '@material-ui/core';

import Sante24Hero from '../../../../../../../images/test-assignment-sante24-hero-fr.png';

const FR = () => (
  <>
    <img
      src={Sante24Hero}
      alt="Order your assigned test"
      className="sidebar__image"
    />
    <div className="sidebar__main-content">
      <Typography variant="body2">
        <br />
        <br />
        Un test de laboratoire à domicile t’a été attribué par <b>santé24</b>.
        <br />
        <br />
        Merci de suivre les étapes suivantes :
        <br />
        <br />
        <b>1. Commander le test</b>
        <br />
        Clique sur le bouton &quot;Commander&quot; à la fin de cet e-mail et
        suis les instructions pour finaliser ta commande
        <br />
        <br />
        <b>À noter :</b> Lors du paiement, CHF 33.00 te seront facturés pour
        l’envoi et le matériel. Il s’agit d’une prestation à la charge du
        patient. Aucun remboursement par l’assurance de base n’est possible. Les
        frais d’analyse seront facturés directement à ton assurance de base. Si
        ta franchise n’a pas encore été atteinte, l’assurance de base
        t’adressera une facture pour les coûts correspondants.
        <br />
        <br />
        <b>2. Réaliser ton test confortablement chez toi</b>
        <br />
        1 à 2 jours ouvrables après la commande, tu recevras ton kit de test
        dans une enveloppe discrète, envoyée par la poste. Le kit contient un
        code d’activation, tout le matériel nécessaire, ainsi que des
        instructions faciles à comprendre pour prélever ton échantillon.
        Ensuite, il te suffit d’emballer l’échantillon dans la boîte de retour
        fournie et de la déposer dans n’importe quelle boîte aux lettres de La
        Poste Suisse.
        <br />
        <br />
        <b>3. Recevoir les résultats</b>
        <br />
        Ton échantillon sera analysé par Medisyn, un prestataire de laboratoire
        suisse de premier plan. Une fois que tes résultats seront prêts, tu
        recevras un appel de santé24 pour les discuter. Après cet appel, tes
        résultats seront disponibles en ligne.
      </Typography>
      <button type="button" className="sidebar__button">
        Commande test attribué
      </button>
      <Typography variant="body2">
        Si tu as des questions, tu peux nous contacter à tout moment à
        l&apos;adresse suivante : service@yourself.health
      </Typography>
    </div>
    <div className="sidebar__footer">
      <Typography variant="body2">
        Health Yourself
        <br />
        <br />
        Lerchenfeldstrasse 3, 9014 St. Gallen, Switzerland
        <br />
        <br />
        Tu ne veux plus recevoir ces e-mails ? Désabonne-toi
        <br />
        <br />© 2025 Health Yourself
      </Typography>
    </div>
  </>
);

export default FR;
